import { Link } from "react-router-dom";

export default function RelatedArticlesSidebar({ articles = [] }) {
    return (
        <aside className="hidden lg:block">
            <div className="sticky top-24">
                <section className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">

                    {/* HEADER */}
                    <div className="px-5 py-4 border-b bg-gray-50">
                        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                            🔗 Contextual Reads
                        </h3>
                        <p className="text-xs text-gray-500 mt-0.5">
                            Expand your understanding
                        </p>
                    </div>

                    {/* LIST */}
                    <div className="p-4 space-y-4">
                        {articles.length === 0 ? (
                            <p className="text-gray-500 text-sm text-center">
                                No related reads available
                            </p>
                        ) : (
                            articles.map((article) => (
                                <Link
                                    to={`/article/${article.slug}`}
                                    key={article.slug}
                                    className="
                                        block
                                        border-l-4 border-purple-500
                                        pl-4 py-2
                                        rounded-md
                                        hover:bg-purple-50
                                        transition
                                        group
                                    "
                                >
                                    {/* META */}
                                    <div className="flex items-center gap-2 mb-1">
                                        <span className="text-[11px] font-medium text-purple-600 bg-purple-100 px-2 py-0.5 rounded">
                                            {article.category || "Related"}
                                        </span>
                                        <span className="text-[11px] text-gray-400">
                                            {article.read_time || "Quick read"}
                                        </span>
                                    </div>

                                    {/* TITLE */}
                                    <p
                                        className="
                                            text-sm font-semibold leading-snug
                                            text-gray-900
                                            group-hover:text-purple-700
                                            transition
                                            line-clamp-2
                                        "
                                    >
                                        {article.title}
                                    </p>

                                    {/* CONTEXT LINE */}
                                    <p className="text-xs text-gray-600 mt-1 line-clamp-2">
                                        {article.context ||
                                            "Provides additional context related to this topic."}
                                    </p>
                                </Link>
                            ))
                        )}
                    </div>

                </section>
            </div>
        </aside>
    );
}
